import { render, staticRenderFns } from "./PackageB.vue?vue&type=template&id=d8cf96b8&"
import script from "./PackageB.vue?vue&type=script&lang=js&"
export * from "./PackageB.vue?vue&type=script&lang=js&"
import style0 from "./PackageB.vue?vue&type=style&index=0&id=d8cf96b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports